import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: 'E-mailadres bevestigen',
  [OnboardingStep.BusinessInfo]: 'Voeg uw winkelgegevens toe',
  [OnboardingStep.PersonalInfo]: 'Voeg uw persoonlijke gegevens toe',
  [OnboardingStep.ShippingInfo]: 'Voeg uw bezorggegevens toe',
  [OnboardingStep.BankInfo]: 'Bankgegevens toevoegen voor uitbetalingen',
  [OnboardingStep.TaxInfo]: 'Is uw bedrijf btw-plichtig?',
  [OnboardingStep.BusinessDocs]: 'Bewijs van bedrijfsdocument',
  [OnboardingStep.PersonalDocs]: 'Identiteitsbewijs',
  [OnboardingStep.InfoSubmission]: 'Betaald worden',
  confirm_info_gateway: 'Betaald worden – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Betalingsgegevens',
  [OnboardingStep.Subscription]: 'Abonnement',
  [OnboardingStep.MobileApp]: 'Mobiele app',
  [OnboardingStep.DeliveryStructure]: 'Bezorgstructuur',
  [OnboardingStep.Contract]: 'Contract',
  [OnboardingStep.ContractPayment]: 'Contractbetaling',
  [OnboardingStep.PromoCode]: 'Promotiecode',
};
